import React from 'react';
import './DiscordInvite.css';
const DiscordInvite = () => {
  const [isVisible, setIsVisible] = React.useState(true);

  if (!isVisible) return null;

  return (
    <div className="discord-invite-container">
      <div className="discord-invite-box">
        <button className="discord-close-btn" onClick={() => setIsVisible(false)} aria-label="Close Discord Invite">
          &times;
        </button>
        <div className="discord-header">
          <h3 className="discord-title">Join us on Discord!</h3>
          <a href="https://discord.com/invite/GDhzHFa8VX" target="_blank" rel="noopener noreferrer" className="discord-link">
            discord.gg/GDhzHFa8VX
          </a>
        </div>
        <div className="discord-body">
          <img
            src={`https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent("https://discord.com/invite/GDhzHFa8VX")}`}
            alt="Discord QR Code"
            className="discord-qr"
          />
          <div className="discord-info">
            <p>Scan the QR code or click the link to join our community.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export { DiscordInvite };